<template>
    <div class="csv-login-wrap">
        <div class="form" v-if="errorMessage.length > 0">
            <p>{{ errorMessage }}</p>
            <router-link
                to="/login"
                class="button-round"
            >
                {{ $t('nav.login') }}
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import api from '@/api';
export default {
    data () {
        return {
            errorMessage: "",
        };
    },
    computed: {
       usrId () {
           return this.$route.query.usrid;
       },
       token () {
           return this.$route.query.token;
       },
    },
    created () {
        this.loginWithToken();
    },
    methods: {
        ...mapActions(['setLoggedIn']),
        async loginWithToken() {
            this.startLoading();
            try {
                const res = await api.loginWithToken({
                    usr_id: this.usrId,
                    token: this.token
                })
                const data = res.data;
                if (data.sid) {
                    const sid = data.sid;
                    localStorage.setItem('sid', sid);
                    this.setLoggedIn(true);
                    this.$router.push("/");
                }
            } catch (error) {
                this.errorMessage = this.$t('csvLogin.linkExpired');
            } finally {
                this.stopLoading();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.csv-login-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    .form {
        display: flex;
        flex-direction: column;
        gap: 1em;
        align-items: center;
        p {
            font-weight: 600;
        }
        a {
            background: var(--button-color-yellow);
            color: #000;
        }
    }
}
</style>